<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" mat-dialog-title>
	<div>What's New</div>
	<button color="primary" fxLayoutAlign="end" mat-dialog-close mat-icon-button>
		<mat-icon>close</mat-icon>
	</button>
</div>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
    <h6>Version {{version}}</h6>
    <img class="whats-new-image" src="assets/images/whats_new.png"/>
    <h3>Enhanced Parcel Tracking</h3>
    <div>
      <p>Parcel Tracking will now allow you to track up to 500 on-demand or routed parcels at a time. That’s right –
        500!
        You can choose to perform a “Quick Search” to view your most recently scanned parcels or select an option from a
        drop-down menu for a variety of tracking values such as barcode, parcel type, status, address, and more.</p>
      <p>Tracking results will display based on your search criteria and input values in an easy-to-read format with the
        most current information. You can view the latest status, last scan date, last scan location, and POD (if
        available) all within the Parcel Tracking window.</p>
      <p>Need more details on a specific parcel? Within the tracking results, each record is clickable to view the
        entire
        lifecycle for that particular parcel. The detailed view shows all pertinent data on the parcel such as delivery
        location, parcel ID, and refrigeration type, and also includes an overview of each scan on the parcel, parcel
        status codes, VPOD (visual proof of delivery) images, delivery signature images, and more.</p>
      <p>The Parcel Tracking option is visible in the left menu of the Client Portal when the feature is enabled.</p>

    </div>
    <div>
      <h3>Need more help?</h3>
    </div>
    <div>
      <p>If you have questions about the functionality, select the icon in the bottom right corner of any page to see
        detailed instructions for that feature.
      </p>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
	<button [color]="'accent'" mat-dialog-close mat-raised-button>
		<span>Close</span>
	</button>
</mat-dialog-actions>
